<div style="margin-bottom: 10px;">
  <div style="float: right;">
    <button type="button" kendoButton [buttonLoading]="loading" themeColor="primary" [svgIcon]="icons.save" (click)="saveChanges()" [disabled]="editedScenarios.size <= 0">Save</button>
    &nbsp;
    @if (editedScenarios.size > 0) {
      <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.cancel" (click)="cancelEdit()" class="cancel-btn">Cancel</button>
    }
  </div>
</div>
<div class="flex-column flex-fill">
  @if (isForecastRunning) {
    <div class="forecast-running-warning">{{ forecastMessage }}</div>
  }
  <div class="tb-container flex-column flex-fill">
    <ag-grid-angular style="height: 100%;" class="ag-theme-balham" [gridOptions]="forecastScenariosGridOptions"
      (cellValueChanged)="onCellValueChanged($event)">
    </ag-grid-angular>
  </div>
</div>